export default __webpack_public_path__ + "static/media/b_leadership_small.a330cdbc.png";